import { SingleChoiceFieldInfo } from '@app/queryTyping';

import { isNotEmptyString } from '@app/common/utils/assertion';

import { MappedSubFields } from './subFieldsMapper';

/**
 * Join labels array to string excluding emty values.
 */
export const formatLabel = (items: Array<string>, separator: string = '') => items.filter(
  (str) => isNotEmptyString(str),
).join(separator);

const USA = 'USA';

const getCountryName = (field: SingleChoiceFieldInfo | undefined) => field?.choiceList?.find(
  (country) => country!.id === field.selectedValue,
)?.text;

/**
 * Map config to specific address format.
 */
export const formatAddress = (config: MappedSubFields): string => {
  const zipCode = config.ZIPCode?.value;
  const zipCodePart = zipCode ? ` ${zipCode}` : '';
  const country = getCountryName(config.Country as SingleChoiceFieldInfo);
  const countryPart = (country && country !== USA) ? `, ${country}` : '';
  const addressPart = formatLabel([
    config.StreetAddress?.value,
    config.StreetAddress2?.value,
    config.City?.value,
    config.MilitaryMailingCities?.selectedValue,
    config.State?.value,
    config.State?.selectedValue,
  ] as Array<string>, ', ');

  return `${addressPart}${zipCodePart}${countryPart}`;
};

/**
 * Map config to specific phone format.
 */
export const formatPhone = (config: MappedSubFields): string => formatLabel([
  config.MobilePhone?.value,
  config.Extension?.value && config.Extension?.label,
  config.Extension?.value,
] as Array<string>, ' ');
